/**
 * Payload CMS client shared by every frontend. Plain TypeScript and `fetch`,
 * no React or Vue, so the React site and the Ionic Vue app read content the
 * same way. Frontends depend on the ContentRepository port in @site/shared;
 * this package is the one adapter behind it.
 */
import type { ContentRepository } from '@site/shared/ports'
import { PayloadHttpClient } from './PayloadHttpClient'
import { PayloadContentRepository } from './PayloadContentRepository'

export { PayloadHttpClient, PayloadContentRepository }

/**
 * @param apiBaseUrl    where this runtime reaches the Payload API (may be internal)
 * @param publicBaseUrl public CMS origin, used for media/file URLs shown to users
 * @param locale        content locale for every request
 */
export function createPayloadRepository(opts: { apiBaseUrl: string; publicBaseUrl: string; locale: string }): ContentRepository {
  return new PayloadContentRepository(new PayloadHttpClient(opts.apiBaseUrl, opts.locale), opts.publicBaseUrl)
}
